module.exports = __webpack_public_path__ + "img/BJ.05523bf0.svg";